<div class="side-menu side-menu-background" [ngStyle]="{'width': collapseMenu ? '180px': '65px'}">
    <ul>
        <li class="fix-top-line arrow-menu" (click)="shrinkEvent()" [ngStyle]="{'justify-content': collapseMenu ? 'flex-end': 'flex-end'}">
            <div class="i-btn btn-wave-effect" style="display: flex;align-items: center;">
                <div *ngIf="collapseMenu">
                    <!-- <img src="../images/new_ui/moveLeft.png"> -->
                    <svg _ngcontent-c0="" class="svg-inline--fa fa-angle-double-left fa-w-14 ng-star-inserted" aria-hidden="true" data-prefix="fas" data-icon="angle-double-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg="">
            <path fill="currentColor" d="M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"></path>
          </svg>
                </div>
                <div *ngIf="!collapseMenu">
                    <!-- <img src="../images/new_ui/moveRight.png"> -->
                    <svg _ngcontent-c0="" class="svg-inline--fa fa-angle-double-right fa-w-14 ng-star-inserted" aria-hidden="true" data-prefix="fas" data-icon="angle-double-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg="">
            <path fill="currentColor" d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"></path>
          </svg>
                </div>
            </div>
        </li>

        <div class="scroll-wrapper">

            <mat-spinner
                *ngIf="loadingMenu"
                mode="indeterminate"
                class="circle cSPCustomerEntitlements-loading"
                diameter="30"
                style="margin: auto auto;"
            >
            </mat-spinner>
            <ng-container *ngIf="!loadingMenu">
                <ng-container *ngFor="let item of authService?.MENU_SECTION_1">
                    <li *ngIf="item.menuName=='Orders'" [class.active]="selectedMenuItem == item.menuId" [class.highlightSection]="tourStep=='step3'" (click)="navigateTo(item)" [ngbPopover]="popContent" triggers="manual" #popoverSide="ngbPopover" placement="right" (click)="routerToBuyComponent(item.menuRouter)"
                        placement="right" [routerLink]="item.menuRouter" [id]="item.menuId" class="menuLink">
                        <a [ngClass]="{'extended-menu':collapseMenu}">
                            <div *ngIf="collapseMenu">
                                <img [src]="item.menuIconPath">
                            </div>
                            <div *ngIf="!collapseMenu">
                                <img [src]="item.menuIconPath" placement="right" ngbTooltip={{item.menuName}} container="body">
                            </div>
                            <span *ngIf="collapseMenu" class="sidebar-name">{{item.menuName}}</span>
                        </a>
                    </li>
                    <li *ngIf="item.menuName!='Orders'" [class.active]="selectedMenuItem == item.menuId" [routerLink]="item.menuRouter" [routerLinkActive]="item.menuId == 'quotes' ? '' : 'active'"  placement="right" [id]="item.menuId" class="menuLink">
                        <a [ngClass]="{'extended-menu':collapseMenu}">
                            <div *ngIf="collapseMenu">
                                <img [src]="item.menuIconPath">
                            </div>
                            <div *ngIf="!collapseMenu">
                                <img [src]="item.menuIconPath" placement="right" ngbTooltip={{item.menuName}} container="body">
                            </div>
                            <span *ngIf="collapseMenu" class="sidebar-name">{{item.menuName}}</span>
                        </a>
                    </li>
                </ng-container>
                <ng-template #popContent>
                    <p><b>Step 3</b> – Access to current and historical orders</p>
                    <button class="button button-red button-mid" (click)="previousTourStepTwo()">Previous Step</button>
                    <button class="button button-red button-mid" (click)="nextTourStep()">Next Step</button>
                </ng-template>
                <ng-container *ngIf="currentUserModel?.source!='SAP'">
    
                    <div class="sidebar-divider"></div>
    
                    <ng-container *ngFor="let item of authService?.MENU_SECTION_2">
                        <li *ngIf="item.menuName=='Account'" [class.highlightSection]="tourStep=='step4'" [class.active]="selectedMenuItem == item.menuId" (click)="navigateTo(item)" routerLinkActive="active" [ngbPopover]="popContentAccount" triggers="manual" #popoverAccount="ngbPopover" (click)="routerToBuyComponent(item.menuRouter)"
                            placement="right" [routerLink]="item.menuRouter" [id]="item.menuId" class="menuLink">
                            <a [ngClass]="{'extended-menu':collapseMenu}">
                                <div *ngIf="collapseMenu">
                                    <img [src]="item.menuIconPath">
                                </div>
                                <div *ngIf="!collapseMenu">
                                    <img [src]="item.menuIconPath" placement="right" ngbTooltip={{item.menuName}} container="body">
                                </div>
                                <span *ngIf="collapseMenu" class="sidebar-name">{{item.menuName}}</span>
                            </a>
                        </li>
                        <li *ngIf="item.menuName!='Account'" [routerLink]="item.menuRouter" routerLinkActive="active" [class.active]="selectedMenuItem == item.menuId" (click)="routerToBuyComponent(item.menuRouter)" placement="right" [id]="item.menuId" class="menuLink">
                            <a [ngClass]="{'extended-menu':collapseMenu}">
                                <div *ngIf="collapseMenu">
                                    <img [src]="item.menuIconPath">
                                </div>
                                <div *ngIf="!collapseMenu">
                                    <img [src]="item.menuIconPath" placement="right" ngbTooltip={{item.menuName}} container="body">
                                </div>
                                <span *ngIf="collapseMenu" class="sidebar-name">{{item.menuName}}</span>
                            </a>
                        </li>
                    </ng-container>
                    <ng-template #popContentAccount>
                        <p><b>Step 4</b> – View and manage Account details, view Account Ledger and make payments</p>
                        <button class="button button-red button-mid" (click)="previousTourStepThree()">Previous Step</button>
                        <button class="button button-red button-mid" (click)="nextTourStepAccount()">Next Step</button>
                    </ng-template>
    
                    <div class="sidebar-divider" *ngIf="authService?.MENU_SECTION_2?.length > 0"></div>
    
                    <li *ngFor="let item of authService?.MENU_SECTION_3" [routerLink]="item.menuRouter" [class.active]="selectedMenuItem == item.menuId" routerLinkActive="active" (click)="routerToBuyComponent(item.menuRouter)" placement="right" [id]="item.menuId" class="menuLink">
                        <a [ngClass]="{'extended-menu':collapseMenu}">
                            <div *ngIf="collapseMenu">
                                <img [src]="item.menuIconPath">
                            </div>
                            <div *ngIf="!collapseMenu">
                                <img [src]="item.menuIconPath" placement="right" ngbTooltip={{item.menuName}} container="body">
                            </div>
                            <span *ngIf="collapseMenu" class="sidebar-name">{{item.menuName}}</span>
                        </a>
                    </li>
    
                    <div class="sidebar-divider"></div>
    
                    <li *ngFor="let item of authService?.MENU_SECTION_4" [routerLink]="item.menuRouter" [class.active]="selectedMenuItem == item.menuId" routerLinkActive="active" (click)="routerToBuyComponent(item.menuRouter)" placement="right" [id]="item.menuId" class="menuLink">
                        <a [ngClass]="{'extended-menu':collapseMenu}">
                            <div *ngIf="collapseMenu">
                                <img [src]="item.menuIconPath">
                            </div>
                            <div *ngIf="!collapseMenu">
                                <img [src]="item.menuIconPath" placement="right" ngbTooltip={{item.menuName}} container="body">
                            </div>
                            <span *ngIf="collapseMenu" class="sidebar-name">{{item.menuName}}</span>
                        </a>
                    </li>
    
                    <div class="sidebar-divider"></div>
    
                </ng-container>
            </ng-container>
            <!-- <li *ngFor="let item of MENULIST5" [routerLink]="item.menuRouter" routerLinkActive="active" (click)="routerToBuyComponent(item.menuRouter)" placement="right" [id]="item.menuId" class="menuLink">
        <a [ngClass]="{'extended-menu':collapseMenu}">
          <img [src]="item.menuIconPath">
          <span *ngIf="collapseMenu" class="sidebar-name">{{item.menuName}}</span>
        </a>
      </li> -->

        </div>

    </ul>
</div>